<script setup lang="ts">
import GwMessage from '@/components/Messages/GwMessage.vue'
import Snackbar from '@/components/Messages/Snackbar.vue'
</script>

<template>
  <Snackbar
    ref="snackbar"
    :canClose="false"
    localKey="study-custom_reports_slow_warning"
    class="d-flex w-100"
    style="
      --position: relative;
      --clr-back: transparent !important;
      padding: 0;
      --close-inset: 0.125rem 0.125rem auto auto;
      max-width: 100%;
      --close-padding: 0.25rem;
      --close-size: 1rem;
    "
  >
    <GwMessage
      class="info-message no-shrink w-100"
      style="position: relative; --z-index-messages: 1"
      :message="{
        icon: 'mdi-information',
        type: 'warning',
      }"
    >
      {{ $t('messages.flops_not_yet_generated') }}
    </GwMessage>
  </Snackbar>
</template>

<style lang="scss" scoped>
.info-message {
  --back-opacity: 0.05;
  --back-padding: 0.25rem 1rem;
  --font-icon: 1.25rem;
  --gap: 0.5rem;
  --font-size: 0.8rem;
  --close-font-size: 2rem;
  --clr-back: var(--clr-black-2);
  border: 1px solid var(--clr-black-1);
  font-weight: 600;
}
</style>
